import {AthubRestResource} from "@/api/rest";
import {DCIM_SERVER} from "@/api";
import athubAxios from "@/util/athub-axios/core";
import {addParamsToUrl} from "@/util";

const equipmentGroup = new AthubRestResource({server: DCIM_SERVER, resource: 'equipment-group'});

equipmentGroup.batchJoin = (groupId, itemIds) => {
    return equipmentGroup.handlePromise(athubAxios.post(
        addParamsToUrl(`${equipmentGroup.server}/${equipmentGroup.resource}/${groupId}/item/batch`, {
            itemIds: itemIds,
        })));
};

equipmentGroup.invalidate = (groupId) => {
    return equipmentGroup.handlePromise(athubAxios.put(`${equipmentGroup.server}/${equipmentGroup.resource}/${groupId}/invalid`));
};

equipmentGroup.revalidate = (groupId) => {
    return equipmentGroup.handlePromise(athubAxios.put(`${equipmentGroup.server}/${equipmentGroup.resource}/${groupId}/valid`));
};

equipmentGroup.findByItemId = (itemId) => {
    return equipmentGroup.handlePromise(athubAxios.get(`${equipmentGroup.server}/${equipmentGroup.resource}/item-id/${itemId}`));
};

export default equipmentGroup;
